import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@core/services/app.service';
import { AppRouteService } from '@shared/services/app-route.service';
import { map, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthStoreService } from '../auth/auth-store.service';
import { ErrorStateService } from '../error/error-state-store.service';
import { ErrorAggregatorService } from '@root/app/error-aggregation/error-aggregator.service';
import { HttpErrorMessageHandlerService } from '@core/error/http-error-message-handler.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly appService = inject(AppService);
  private readonly router = inject(Router);
  private readonly authStoreService = inject(AuthStoreService);
  private readonly errorStateService = inject(ErrorStateService);
  private readonly httpErrorMessageHandlerService = inject(
    HttpErrorMessageHandlerService
  );
  private readonly errorAggregatorService = inject(ErrorAggregatorService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next
      .handle(request)
      .pipe(
        catchError((error: unknown) => {
          this.appService.isLoading.next(false);
          if (error instanceof HttpErrorResponse) {
            this.httpErrorMessageHandlerService.handleGeneralHttpErrorMessage(
              error
            );
            this.errorAggregatorService.addHttpErrorToAggregationError(
              request,
              error
            );
            switch (error.status) {
              case HttpStatusCode.Unauthorized:
                this.authStoreService.logout();
                break;
              case HttpStatusCode.Forbidden:
                this.router.navigateByUrl(AppRouteService.forbiddenPath());
                break;
              case HttpStatusCode.HttpVersionNotSupported:
                this.errorStateService.setErrorState({
                  state: 'versionNoSupported',
                  message: error.error.reason,
                });
                break;
            }
          }

          return throwError(() => error);
        })
      )
      .pipe(
        map<HttpEvent<unknown>, HttpEvent<unknown>>(
          (event: HttpEvent<unknown>) => {
            if (event instanceof HttpResponse) {
              this.appService.isLoading.next(false);
            }
            return event;
          }
        )
      );
  }
}
